import React, { useState, useEffect } from 'react';

interface RiskAppetiteMetricsProps {
  projectId: string;
}

interface AppetiteMetric {
  name: string;
  currentValue: number;
  threshold: number;
  trend: 'up' | 'down' | 'stable';
  trendText: string;
}

export const RiskAppetiteMetrics: React.FC<RiskAppetiteMetricsProps> = ({ projectId }) => {
  const [metrics, setMetrics] = useState<AppetiteMetric[]>([]);

  useEffect(() => {
    // Mock data - in reality this would come from the backend
    setMetrics([
      {
        name: '# of Enterprise Critical Vendors with open high and very high risk issues',
        currentValue: 1,
        threshold: 3,
        trend: 'down',
        trendText: '↓ Decreased from 2 last quarter'
      },
      {
        name: '# of Critical path processes that have an open high and very-high risk issues',
        currentValue: 0,
        threshold: 0,
        trend: 'stable',
        trendText: '→ No change'
      },
      {
        name: 'SOX exceptions related to financial reporting',
        currentValue: 0,
        threshold: 0,
        trend: 'stable',
        trendText: '→ No exceptions'
      }
    ]);
  }, [projectId]);

  const getStatusColor = (current: number, threshold: number, trend: string) => {
    if (current <= threshold) {
      return 'text-green-600';
    } else if (trend === 'down') {
      return 'text-yellow-600';
    } else {
      return 'text-red-600';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm mb-6">
      <div className="bg-[#30A8CF] text-white px-6 py-4 rounded-t-lg">
        <h3 className="text-lg font-semibold">Process-Level Risk Appetite Metrics</h3>
      </div>
      
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {metrics.map((metric, index) => (
            <div key={index} className="bg-[#C1E5F5] p-4 rounded-lg border-l-3 border-[#57C8F4]">
              <div className="text-sm font-medium text-[#221551] mb-3 leading-tight">
                {metric.name}
              </div>
              
              <div className="flex items-center justify-between mb-2">
                <span className={`text-2xl font-bold ${getStatusColor(metric.currentValue, metric.threshold, metric.trend)}`}>
                  {metric.currentValue}
                </span>
                <span className="text-sm text-[#454F83]">
                  Threshold: ≤{metric.threshold}
                </span>
              </div>
              
              <div className="text-xs text-gray-600">
                {metric.trendText}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};